import { Country } from '@types';

export const countryFlags = {
    [Country.GB]: '🇬🇧',
    [Country.US]: '🇺🇸',
};
